"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("../../utils/underscore");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _Functions = require("../../core/Functions");

var BLANK_REGEX = /^\s*$/;
var MINUS_SIGN = "\u2212";
var INVALID_CHARS_REGEX = new RegExp("[^0-9.," + MINUS_SIGN + "-]", 'g');
var NUMBER_TYPES = {
  DECIMAL: 'decimal',
  PERCENTAGE: 'percentage'
};

var formatPercentage = function formatPercentage(value) {
  return _I18n.default.formatPercentage(value, {
    precision: value % 1 === 0 ? 0 : 2
  });
};

var getParsedValue = function getParsedValue(rawValue, parser) {
  if (parser) {
    var parserResult = parser(rawValue);

    if (parserResult != null && typeof parserResult !== 'number') {
      if (process.env.NODE_ENV !== 'production') {
        _devLogger.default.warn({
          message: "UIAbstractNumberInput: Expected `parser(value)` to return a number or null, but " + ("it returned `" + parserResult + "`."),
          key: 'UIAbstractNumberInput: bad parser result'
        });
      }
    } else {
      return parserResult;
    }
  }

  var valueToParse = String(rawValue); // Ignore extraneous characters

  valueToParse = valueToParse.replace(INVALID_CHARS_REGEX, '');
  var parsedValue = BLANK_REGEX.test(valueToParse) ? null : _I18n.default.parseNumber(valueToParse);
  return parsedValue;
};

var getValueIsValid = function getValueIsValid(value) {
  return value == null || value === '' || !(0, _underscore.isNaN)(_I18n.default.parseNumber(value));
};

var getFormattedNumber = function getFormattedNumber(value, formatStyle, formatter) {
  if (formatter) {
    var formatterResult = formatter(value);

    if (typeof formatterResult !== 'string') {
      if (process.env.NODE_ENV !== 'production') {
        _devLogger.default.warn({
          message: "UIAbstractNumberInput: Expected `formatter(value)` to return a string, but " + ("it returned `" + formatterResult + "`."),
          key: 'UIAbstractNumberInput: bad formatter result'
        });
      }
    } else {
      return formatterResult;
    }
  }

  if (value == null || value === '') {
    return '';
  }

  if (!getValueIsValid(value)) {
    return value;
  }

  if (formatStyle === NUMBER_TYPES.PERCENTAGE) {
    return formatPercentage(value);
  }

  return _I18n.default.formatNumber(value);
};

var getStateOnValueReset = function getStateOnValueReset(value, formatStyle, formatter) {
  var isValid = getValueIsValid(value);
  return {
    isValid: isValid,
    lastValidValue: isValid ? value : null,
    displayedValue: getFormattedNumber(value, formatStyle, formatter)
  };
};

var UIAbstractNumberInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIAbstractNumberInput, _Component);

  function UIAbstractNumberInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractNumberInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAbstractNumberInput).call(this, props));

    _this.handleChange = function (evt) {
      // Trigger onChange with the numeric value, not the raw string
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max,
          parser = _this$props.parser;
      var rawValue = evt.target.value;

      _this.setState({
        displayedValue: rawValue
      }); // Prevent formatting while the user is typing


      _this.isTyping = true;
      var parsedValue = getParsedValue(rawValue, parser);

      if (value != null && parsedValue == null) {
        (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent.default)(null));
        return;
      }

      if (parsedValue !== value && !(0, _underscore.isNaN)(parsedValue)) {
        var fencedMin = min == null ? parsedValue : Math.max(parsedValue, min);
        var fencedValue = max == null ? fencedMin : Math.min(fencedMin, max);
        (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent.default)(fencedValue));
      }
    };

    _this.handleBlur = function (evt) {
      var onBlur = _this.props.onBlur;

      _this.handleConfirmedInput();

      _this.isTyping = false;
      (0, _Functions.callIfPossible)(onBlur, evt);
    };

    _this.handleFocus = function (evt) {
      var onFocus = _this.props.onFocus; // If displayedValue is invalid, clear it on focus

      var isValid = _this.state.isValid;

      if (!isValid) {
        _this.setState({
          isValid: true,
          displayedValue: ''
        });
      }

      (0, _Functions.callIfPossible)(onFocus, evt);
    };

    _this.handleConfirmedInput = function () {
      // Format whatever the user typed for display (e.g. "1234" -> "1,234")
      var _this$props2 = _this.props,
          formatStyle = _this$props2.formatStyle,
          formatter = _this$props2.formatter,
          value = _this$props2.value;
      var isValid = getValueIsValid(value);

      _this.setState({
        isValid: isValid,
        displayedValue: getFormattedNumber(value, formatStyle, formatter)
      });
    };

    _this.handleKeyUp = function (evt) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          onKeyUp = _this$props3.onKeyUp,
          value = _this$props3.value;
      var lastValidValue = _this.state.lastValidValue;
      var key = evt.key; // If ESC is pressed, reset to lastValidValue

      if (key === 'Escape' && lastValidValue !== value) {
        (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent.default)(lastValidValue));
        _this.escKeyUpTriggered = true;
      } // If Enter or Up/Down is pressed, update the displayed value


      if (key === 'Enter' || key === 'ArrowUp' || key === 'ArrowDown') {
        _this.handleConfirmedInput();
      }

      (0, _Functions.callIfPossible)(onKeyUp, evt);
    };

    var _value = props.value,
        _formatStyle = props.formatStyle,
        _formatter = props.formatter;
    _this.state = getStateOnValueReset(_value, _formatStyle, _formatter);
    return _this;
  }

  (0, _createClass2.default)(UIAbstractNumberInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props4 = this.props,
          value = _this$props4.value,
          formatStyle = _this$props4.formatStyle,
          formatter = _this$props4.formatter; // Uses this flag to determine if the last change was triggered by the `ESC` key.
      // This logic is separate from the following logic since value and nextProps.value
      // could be equal, and you would still want this reset to trigger. (1000 vs 1,000)

      if (this.escKeyUpTriggered) {
        this.setState(getStateOnValueReset(nextProps.value, nextProps.formatStyle, nextProps.formatter));
        this.escKeyUpTriggered = false;
        return;
      } // Ignore changes from one invalid value (NaN) to another


      var valueChanged = value !== nextProps.value && !((0, _underscore.isNaN)(value) && (0, _underscore.isNaN)(nextProps.value));
      var formatStyleChanged = formatStyle !== nextProps.formatStyle;
      var formatterChanged = formatter !== nextProps.formatter;

      if (valueChanged || formatStyleChanged || formatterChanged) {
        if (!this.isTyping) {
          this.setState(getStateOnValueReset(nextProps.value, nextProps.formatStyle, nextProps.formatter));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          error = _this$props5.error,
          __formatter = _this$props5.formatter,
          __parser = _this$props5.parser,
          __onChange = _this$props5.onChange,
          __value = _this$props5.value,
          __formatStyle = _this$props5.formatStyle,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["children", "error", "formatter", "parser", "onChange", "value", "formatStyle"]);
      return children((0, _extends2.default)({}, rest, {
        'aria-invalid': typeof error === 'boolean' ? error : !this.state.isValid,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        value: this.state.displayedValue
      }));
    }
  }]);
  return UIAbstractNumberInput;
}(_react.Component);

exports.default = UIAbstractNumberInput;
UIAbstractNumberInput.propTypes = {
  children: _propTypes.default.func.isRequired,
  error: _propTypes.default.bool,
  formatStyle: _propTypes.default.oneOf(Object.keys(NUMBER_TYPES).map(function (k) {
    return NUMBER_TYPES[k];
  })),
  formatter: _propTypes.default.func,
  parser: _propTypes.default.func,
  onChange: _propTypes.default.func,
  value: _propTypes.default.number,
  min: _propTypes.default.number,
  max: _propTypes.default.number
};
UIAbstractNumberInput.defaultProps = {
  error: undefined,
  // needed to override UITextInput's default
  formatStyle: undefined
};
UIAbstractNumberInput.displayName = 'UIAbstractNumberInput';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/input/abstract/UIAbstractNumberInput.js
// module id = 438
// module chunks = 5 6